/* eslint-disable max-len */

export default {
    name       : 'operationFiscalItems',
    /**
     * @override
     */
    data() {
        return {
            fiscalItems: []
        };
    },
    props: {
        uuid: {
            type: String,
            required: true
        }
    },
    methods: {
        /**
         * Obtenemos las partidas fiscales de la operacion
         */
        fetchData() {
            this.$operationsService.getOperationFiscalItems(this.uuid)
                .then(res => {
                    this.fiscalItems.items = res.data.operations_fiscal_items || [];
                });
        }
    },
    /**
     * @override
     */
    beforeMount() {

        this.fiscalItems = {
            fields: [
                {
                    key: 'disposal_date',
                    label: 'Fecha reembolso'
                },
                {
                    key: 'purchase_date',
                    label: 'Fecha suscripción'
                },
                {
                    key: 'purchase_key_operation_type',
                    label: 'Tipo sus.'
                },
                {
                    key: 'fiscal_years',
                    label: 'Ejerc. Fisc.'
                },
                {
                    key: 'disposal_shares',
                    label: 'Participaciones'
                },
                {
                    key: 'disposal_nav',
                    label: 'Liquidativo'
                },
                {
                    key: 'purchase_price',
                    label: 'Coste efectivo'
                },
                {
                    key: 'disposal_amount',
                    label: 'Importe reembolso'
                },
                {
                    key: 'profit',
                    label: 'Valías'
                },
                {
                    key: 'inflationary_ratio',
                    label: 'Coef. Act.'
                },
                {
                    key: 'inflationary_price',
                    label: 'Coste fiscal actual.'
                },
                {
                    key: 'inflationary_profit',
                    label: 'Valías Act.'
                },
                {
                    key: 'reducted_fiscal_income',
                    label: 'Valías Reduc.'
                },
                {
                    key: 'reduction_ratio',
                    label: '% Reduc.'
                },
                {
                    key: 'reducted_gross_amount',
                    label: 'Reduc.'
                },
                {
                    key: 'fiscal_income',
                    label: 'Valía fiscal'
                }
            ],
            items: []
        };
        this.fetchData();
    }
};
